var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{key:'button1',staticClass:"button1"},[_c('w-button',{staticClass:"buttonRecorder",attrs:{"data-test":"recorderMicMuteButton","enabled":!_vm.isWebcamFull && !_vm.isWebcamIntegration,"icon":_vm.muteIcon,"size":_vm.size,"color":_vm.color},on:{"click":_vm.switchMute}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }